module.exports = __webpack_public_path__ + "img/playstore.efeef553.png";